// Présentation uniquement : ne détermine pas les droits de prise en charge.
const texte = valeur => valeur == null ? '' : String(valeur).trim()
export const normaliserRecherche = valeur => texte(valeur).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
const dateISO = valeur => {
    const jour = texte(valeur).slice(0, 10)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(jour)) return ''
    const d = new Date(jour + 'T00:00:00Z')
    return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === jour ? jour : ''
}
const dateFr = valeur => valeur.split('-').reverse().join('/')
export function jourLocal() {
    const d = new Date()
    return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-')
}
export function ligneAnnuaire(fiche, aujourdHui = jourLocal()) {
    const convention = fiche.type_tiers === 'convention'
    const nombre = fiche.nombre_contrats == null ? null : Number(fiche.nombre_contrats)
    const c = fiche.apercu_contrat
    let statut = 'Non renseigné', ton = 'neutre', periode = ''
    if (!convention) statut = nombre == null ? 'À consulter' : nombre + ' société' + (nombre > 1 ? 's' : '') + ' souscriptrice' + (nombre > 1 ? 's' : '')
    else if (nombre === 0) statut = 'À définir'
    else if (nombre > 1) { statut = 'À vérifier'; ton = 'attention'; periode = nombre + ' contrats rattachés' }
    else if (c) {
        const debut = dateISO(c.date_effet), fin = dateISO(c.date_expire_le)
        if (debut) {
            periode = 'Du ' + dateFr(debut) + (fin ? ' au ' + dateFr(fin) : ' · sans date de fin')
            if ((fin && fin < debut) || (texte(c.date_expire_le) && !fin)) { statut = 'Dates à vérifier'; ton = 'attention' }
            else if (fin && fin < aujourdHui) { statut = 'Expiré'; ton = 'attention' }
            else if (debut > aujourdHui) { statut = 'À venir'; ton = 'bleu' }
            else { statut = 'En cours'; ton = 'succes' }
        } else { statut = 'Dates à compléter'; ton = 'attention' }
    }
    let mode = 'Non renseignée', precisions = []
    if (c) {
        const forfait = Number(c.a_model_forfait) === 1
        mode = forfait ? 'Forfait' : 'À l’acte'
        if (forfait) precisions.push(Number(c.duree_forfait) > 0 ? 'Couverture : ' + c.duree_forfait + ' j' : 'Couverture à compléter')
        precisions.push(c.num_bon_is_required == null || Number(c.num_bon_is_required) === 1 ? 'Bon obligatoire' : 'Bon facultatif')
        if (texte(c.prefixe_reference_facture)) precisions.push('Préfixe : ' + texte(c.prefixe_reference_facture))
    }
    // Les anciens enregistrements peuvent ne contenir que l'indicatif téléphonique.
    const telephone = texte(fiche.telephone).replace(/^\+\d{1,4}\s*$/, '')
    const ligne = { ...fiche, nom: texte(fiche.compagnie_assurance || fiche.raison_sociale), telephone,
        email: texte(fiche.email), adresse: texte(fiche.adresse), statut, ton, periode, mode, precisions }
    ligne.recherche = normaliserRecherche([ligne.nom, telephone, ligne.email, ligne.adresse, statut, periode, mode, ...precisions].join(' '))
    return ligne
}
